export const redirect = (location: string) => {
  window.location.href = location;
};

export const replaceRedirect = (location: string) => {
  window.location.replace(location);
};

export type LinkTarget = '_blank' | '_self' | '_parent' | '_top';
